export default __webpack_public_path__ + "add-user-sm.df052c13.svg";